export enum ECSSPropertyUnit {
  px = 'px',
  percent = '%',
}
